export const sessionKeys = {
  accessToken: 'accessToken',
  affiliateID: 'affiliateID',
  agentId: 'agentId',
  callLogId: 'callLogId',
  cjevent: 'cjevent',
  custId: 'custId',
  ffAttemptedToken: 'ff_attempted_token',
  ffFallbackReported: 'ff_fallback_reported',
  isHome: 'isHome',
  nbc: 'nbc',
  promoCode: 'promoCode',
  refreshToken: 'refreshToken',
  securityAns: 'securityAns',
  securityQue: 'securityQue',
  sessionOrderAccessToken: 'sessionOrderAccessToken',
  tfn: 'tfn',
  HomeUrl: 'homeUrl'
};
